import styled from 'styled-components';

import { withLayoutProps } from '@/utils/withLayoutProps';

export const StyledItineraryBlockContainer = styled.div<{ $dashed?: boolean; $showBorder?: boolean }>`
  display: flex;
  flex-direction: column;
  position: relative;
  padding-bottom: 5rem;
  ${(props) =>
    props.$showBorder &&
    `
     border-left: 3px ${props?.$dashed ? 'dashed' : 'solid'} ${props.theme.color.bodyTextColor};
    `};
`;

export const StyledItineraryBlockBackground = styled.div<{ $fullWidth?: boolean }>`
  // full width compensates the offset and covers the whole block
  width: ${(props) => (props.$fullWidth ? 'calc(100% + 70px)' : '100%')};
  height: 100%;

  background-color: ${(props) => `${props.theme.color.primaryLightBackground}`};
  border-radius: 15px;

  position: absolute;
  left: -35px;
  top: -30px;
  z-index: -1;
`;

export const StyledItineraryBlockCard = withLayoutProps(styled.div`
  display: flex;
  gap: 25px;
  padding: 0 25px 25px 25px;
`);

export const StyledDot = styled.div`
  width: 10px;
  height: 10px;
  background-color: ${(props) => props.theme.color.bodyTextColor};
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 5px;
  transform: translateY(-50%);
`;
export const StyledDotBackground = styled.div`
  width: 20px;
  height: 20px;
  background-color: ${(props) => `${props.theme.color.bodyTextColor}20`};
  position: absolute;
  border-radius: 50%;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
`;
export const StyledDotPlacement = styled.div<{ $isOnBackground?: boolean }>`
  max-width: 20px;
  margin-left: -12.5px;
  padding: 20px 10px;
  height: 40px;
  background-color: ${(props) =>
    props.$isOnBackground ? props.theme.color.primaryLightBackground : props.theme.color.white};
  position: relative;
`;
export const LogoPlacement = styled.div`
  position: relative;
`;
export const Logo = styled.img`
  position: absolute;
  top: 1rem;
  left: 3rem;
  width: 10rem;
`;
export const StyledPrintButton = styled.button`
  color: ${(props) => props.theme.color.bodyTextColor};
  text-decoration: underline;
  font-weight: 600;
  margin-left: 5px;
  &:hover {
    color: ${(props) => props.theme.color.primary};
    cursor: pointer;
  }
`;
export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 6px;
  gap: 10px;
  min-width: 20rem;
`;
export const StyledItem = withLayoutProps(styled.div`
  display: flex;
  flex-direction: column;
  min-width: 20rem;
`);
export const StyledOtherButton = styled.button<{ $open?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: ${(props) => props.theme.color.primary};
  cursor: pointer;
  svg {
    transition: transform 0.3s ease;
    transform: ${(props) => (props.$open ? 'rotate(180deg)' : 'rotate(0deg)')};
  }
  &:hover {
    text-decoration: underline;
  }
`;
